import { WinkEmojiDivider } from '@openeducation/oe-it-components';
import * as React from 'react';

import { BoxMessage } from '../../molecules/box-message/box-message';

export const NoPCPendingFeedbacks = () => {
  return (
    <BoxMessage
      title="Hi! You are not assigned a private class right now"
      body="This page is only active when you have a private class in progress."
      divider={<WinkEmojiDivider />}
      padding={40}
    />
  );
};
